import { useContext } from 'react';
import {
  DownloadProjectSummaryContext,
  SaveProjectSummaryContext,
} from './Context';

export const useDownloadProjectSummary = (downloadName: string) => useContext(DownloadProjectSummaryContext)(downloadName);
export const useSaveProjectSummary = () => useContext(SaveProjectSummaryContext);
